import { Categories } from 'emoji-picker-react';

export const EMOJI_CATEGORIES = [
  {
    category: Categories.SUGGESTED,
    nameKey: 'Chat.EmojiPicker.categories.suggested',
  },
  {
    category: Categories.CUSTOM,
    nameKey: 'Chat.EmojiPicker.categories.custom',
  },
  {
    category: Categories.SMILEYS_PEOPLE,
    nameKey: 'Chat.EmojiPicker.categories.smileysPeople',
  },
  {
    category: Categories.ANIMALS_NATURE,
    nameKey: 'Chat.EmojiPicker.categories.animalsNature',
  },
  {
    category: Categories.FOOD_DRINK,
    nameKey: 'Chat.EmojiPicker.categories.foodDrink',
  },
  {
    category: Categories.TRAVEL_PLACES,
    nameKey: 'Chat.EmojiPicker.categories.travelPlaces',
  },
  {
    category: Categories.ACTIVITIES,
    nameKey: 'Chat.EmojiPicker.categories.activities',
  },
  {
    category: Categories.OBJECTS,
    nameKey: 'Chat.EmojiPicker.categories.objects',
  },
  {
    category: Categories.SYMBOLS,
    nameKey: 'Chat.EmojiPicker.categories.symbols',
  },
  {
    category: Categories.FLAGS,
    nameKey: 'Chat.EmojiPicker.categories.Flags',
  },
] as const;
